import { Theme } from '@mui/material'

const useStyles = {
  container: () => ({
    paddingTop: 0.5,
    flexDirection: 'column',
  }),
  desktopHeader: (theme: Theme) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    paddingTop: 2,
    paddingBottom: 1,
    fontWeight: 500,
    color: theme.palette.text.secondary,
  }),
  orderHistoryContainer: {
    paddingY: 2,
    gap: 1,
  },
  orderCardButton: {
    width: '100%',
  },
  orderCard: (theme: Theme) => ({
    backgroundColor: theme.palette.common.white,
    borderRadius: 2,
    flexDirection: 'column',
    minHeight: '88px',
    paddingBottom: 0.5,
    gap: 0.5,
    alignItems: 'center',
  }),
  selectedOrderCard: (theme: Theme) => ({
    backgroundColor: theme.palette.secondary.light,
  }),
  orderCardHeader: {
    paddingY: '12px',
    paddingX: 2,
    gap: 2,
    alignItems: 'flex-start',
    width: '100%',
  },
  orderDetailsColumn: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '6px',
    flex: 1,
  },
  orderInformation: {
    flexDirection: 'column',
    justifyContent: 'start',
    alignItems: 'start',
  },
  orderLabel: (theme: Theme) => ({
    fontWeight: 500,
    color: theme.palette.text.secondary,
    textTransform: 'uppercase !important',
  }),
  secondaryText: {
    color: 'text.secondary',
  },
  trackShipmentButton: {
    marginY: 1,
  },
  orderDetailsContainer: {
    paddingY: 1,
    gap: 1,
  },
  orderDetailsHeader: {
    alignItems: 'center',
    paddingTop: 2,
    paddingBottom: 2,
  },
  orderDetailsHeaderColumn: {
    padding: 1,
    gap: '6px',
    flex: 1,
    flexDirection: 'column',
  },
  orderDetailsDrawerPaper: (theme: Theme) => ({
    backgroundColor: theme.palette.ui.surfaceContainer,
  }),
  orderListContainer: (theme: Theme) => ({
    padding: 2,
    gap: 2,
    flexDirection: 'column',
    backgroundColor: theme.palette.background.paper,
    borderRadius: '12px',
  }),
  orderListTitle: {
    fontWeight: 600,
  },
  orderListGrid: (orderItemsLength: number) => ({
    display: 'grid',
    rowGap: 0.5,
    gridTemplateRows: `repeat(${orderItemsLength + 1}, fit-content(100%))`,
    gridTemplateColumns: 'fit-content(100%) minmax(0, 1fr)',
  }),
  orderListHeaderQuantity: {
    fontWeight: 500,
    padding: 1,
    textAlign: 'center',
  },
  orderListHeaderItem: {
    fontWeight: 500,
    padding: 1,
  },
  orderListQuantityText: (theme: Theme) => ({
    color: theme.palette.text.secondary,
    padding: 1,
    textAlign: 'center',
  }),
  orderListItemText: (theme: Theme) => ({
    color: theme.palette.text.secondary,
    padding: 1,
  }),
  noHistoryAlert: {
    width: '100%',
  },
}

export default useStyles
